export function isBreakoutCable ({ cableType }) {
  const breakoutCableTypes = ['I-V(ZN)HH', 'I-F(ZN)HH']

  return breakoutCableTypes.includes(cableType)
}